// Opening WhatsApp. A website can't take over a tab you opened yourself, so there are two ways:
//  • "app": the WhatsApp desktop app (if installed), via its whatsapp:// link — no new tab.
//  • "tab": one WhatsApp Web tab that the CRM opens the first time and reuses after that.
// The choice is per device (Settings → Your profile).

export type WaMode = "app" | "tab";
const KEY = "rca.whatsapp";

export function waMode(): WaMode {
  try { return localStorage.getItem(KEY) === "app" ? "app" : "tab"; } catch { return "tab"; }
}
export function setWaMode(m: WaMode) {
  try { localStorage.setItem(KEY, m); } catch { /* private mode: default */ }
}

/** Phone → WhatsApp number (10-digit North American numbers get the 1). */
export function waDigits(phone?: string | null) {
  const d = (phone ?? "").replace(/\D/g, "");
  if (!d) return null;
  return d.length === 10 ? "1" + d : d;
}

export function openWhatsApp(phone: string | null | undefined, text?: string) {
  const n = waDigits(phone);
  if (!n) return false;
  const t = text ? `&text=${encodeURIComponent(text)}` : "";
  if (waMode() === "app") window.location.href = `whatsapp://send?phone=${n}${t}`;
  else window.open(`https://web.whatsapp.com/send?phone=${n}${t}`, "rca_whatsapp");
  return true;
}
